module.exports = __webpack_public_path__ + "media/images/pc/stores/common/appeal_01@3x-5b799dcfc30ff7061aed1560a4b33d0e.webp";